'use strict';

var $ = require('jquery');

module.exports = (function() {
  var globals = {
    $body: $('body'),
    $html: $('html'),
    $window: $(window),
    $document: $(document),
    $htmlBody: $('html, body')
  };
  globals.$head = globals.$body.find('header.head');
  globals.$footer = globals.$body.find('footer.Footer');

  globals.setHeader = () => {
    if (!globals.$head.length) {
      globals.$head = globals.$body.find('header.head');
    }
  }

  globals.setFooter = () => {
    if (!globals.$footer.length) {
      globals.$footer = globals.$body.find('footer.Footer');
    }
  }
  return globals;
}());



// WEBPACK FOOTER //
// ./assets/js/globalElements.js